<script lang="ts">
	import { pick } from "svelte-routing/src/utils";
	import { globalHistory } from "svelte-routing/src/history";

	type HeaderInfo = {
		title: string;
		clickEvent: () => void;
		route: string;
	};

	export let headerInfos: HeaderInfo[] = [];

	let path = window.location.pathname;

	const navWidth = (length: number) => {
		return `width : calc(100% / ${length})`;
	};

	$: matched = pick(
		headerInfos.map((v) => ({ path: v.route })),
		path
	);

	globalHistory.listen((v) => (path = v.location.pathname));

</script>

<div class="container">
	<div class="navs">
		{#each headerInfos as headerInfo}
			<div
				class="nav"
				class:active={matched?.route?.path === headerInfo.route}
				style={navWidth(headerInfos.length)}
				on:click={headerInfo.clickEvent}>
				{headerInfo.title}
			</div>
		{/each}
	</div>
	<div class="contents">
		<slot />
	</div>
</div>

<style lang="scss">
	@import "../variables.scss";
	div {
		box-sizing: border-box;
	}
	//Mobile First
	.container {
		position: relative;
		display: flex;
		flex-direction: column;
		width: 100%;
		min-height: 100%;
		gap: 10px;
		.navs {
			margin-top: 50px;
			display: flex;
			width: 100%;
			overflow-x: auto;
			gap: 10px;
			letter-spacing: -0.64px;
			.nav {
				border-radius: 1px;
				border-bottom: 2px solid #bcbfc3;
				color: #bcbfc3;
				text-align: center;
				padding: 10px 0;
				font-weight: 500;
				transition: color 0.5s, border-bottom 0.5s;
				&:hover {
					cursor: pointer;
					color: var(--default-hover-btn-1);
					border-bottom: 2px solid var(--default-hover-btn-1);
				}

				&.active {
					color: var(--signature-blue);
					border-bottom: 2px solid var(--signature-blue);
				}
			}
		}
	}

	/* Dekstop */
	@include DesktopSize {
		.container {
			gap: 30px;
			.navs {
				margin-top: 10px;
				gap: 31px;
				letter-spacing: -0.8px;
				.nav {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
